<template>
  <div class="notice-detail">
    <div class="card">
      <div class="title">
        进出详情
      </div>
      <div class="avatar">
        <img
          :src="data.signAvatar"
          alt=""
          @click="previewImg(data.signAvatar)"
        />
        <div class="name">{{ data.name }}</div>
      </div>
      <div class="group">
        <div class="cell">
          <label>时间：</label><span>{{ data.signTime }}</span>
        </div>
        <div class="cell">
          <label>位置：</label><span>{{ data.location }}</span>
        </div>
        <div class="cell">
          <label>方向：</label><span>{{ data.direction }}</span>
        </div>
        <div class="cell">
          <label>学校：</label><span>{{ data.schoolName }}</span>
        </div>
        <div class="cell" v-if="data.remark">
          <label>备注：</label><span>{{ data.remark }}</span>
        </div>
        <div class="cell" v-if="data.snapVideoUrl" style="display: flex;">
          <label>视频：</label>
          <video width="200" style="flex:1" controls ref='video' controlslist="nodownload" autoplay loop muted
            x5-video-player-fullscreen="true" webkit-playsinline="true" x-webkit-airplay="true" initial-time='0.01'
            playsinline="true" x5-playsinline>
            <source :src="data.snapVideoUrl || tvPlayUrl" type="video/mp4">
          </video>
        </div>
      </div>
    </div>

   
  </div>
</template>

<script>
import moment from 'moment'
import { ImagePreview } from 'vant'

export default {
  name: 'notice-details',
  
  data() {
    return {
      signAvatar: '',
      list: [],
      data: {},
      tvPlayUrl: 'http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4'
    }
  },
  created() {
    this.getNoticeDetail()
  },
  methods: {
    previewImg(imgurl) {
      ImagePreview({
        images: [imgurl],
        closeOnPopstate: true,
      })
    },
    getNoticeDetail() {
      this.axios
        .get(`student-consumer/api/identifyNotice/getIdentifyNotice`, {
          params: {
            id: this.$route.query.id,
          },
        })
        .then((res) => {
          if (res.code === 200) {
            if (res.data) {
              this.data = res.data
              this.data.signTime =
                (res.data.signTime &&
                  moment(res.data.signTime).format('YYYY-MM-DD HH:mm:ss')) ||
                '--'
              this.data.direction =
                res.data.direction == 1
                  ? '进'
                  : res.data.direction == 2
                  ? '出'
                  : '无'
              this
            }
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>

<style lang="scss" scope>
.notice-detail {
  padding-top: 1rem;
  .card {
    .title {
      padding: 0.8rem 1rem;
      font-size: 0.8rem;
      color: #969799;

      border-bottom: 1px solid rgba(244, 244, 246, 0.99);
    }
    margin: 0 1rem 1rem;
    background: #fff;
    /* height: 10rem; */
    box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);

    border-radius: 0.75rem;
    .avatar {
      padding: 1rem 0;
      .name {
        text-align: center;
        font-size: 0.75rem;
        margin-top: 0.7rem;
        color: #969799;
      }
    }
    img {
      width: 4rem;
      height: 4rem;
      border-radius: 50%;
      margin: 0 auto;
      display: block;
      object-fit: cover;
    }
    .group {
      font-size: 0.85rem;
      .cell {
        padding: 0.8rem 0;
        border-bottom: 1px solid rgba(244, 244, 246, 0.99);
        margin: 0 1rem;
        &:last-child {
          border-bottom: none;
        }
        label {
          width: 2.5rem;
          color: #969799;
          display: inline-block;
          font-size: 0.75rem;
        }
      }
    }
  }
}
</style>
